var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
import { forwardRef } from "react";
const SvgProfile = (props, ref) => /*#__PURE__*/React.createElement("svg", _extends({
  xmlns: "http://www.w3.org/2000/svg",
  width: 40,
  height: 40,
  fill: "none",
  viewBox: "0 0 40 40",
  ref: ref
}, props), _g || (_g = /*#__PURE__*/React.createElement("g", {
  clipPath: "url(#a)"
}, /*#__PURE__*/React.createElement("g", {
  clipPath: "url(#b)"
}, /*#__PURE__*/React.createElement("g", {
  clipPath: "url(#c)"
}, /*#__PURE__*/React.createElement("rect", {
  width: 40,
  height: 40,
  fill: "transparent",
  rx: 20
})), /*#__PURE__*/React.createElement("path", {
  fill: "currentColor",
  fillRule: "evenodd",
  d: "M14.757 24.59c1.521-.876 3.364-1.34 5.244-1.34s3.723.464 5.244 1.34c1.521.875 2.663 2.13 3.19 3.605a.75.75 0 1 1-1.413.504c-.385-1.077-1.251-2.076-2.525-2.81-1.273-.732-2.854-1.139-4.496-1.139s-3.223.407-4.496 1.14-2.14 1.732-2.525 2.81a.75.75 0 1 1-1.413-.505c.527-1.474 1.669-2.73 3.19-3.605M20 12.75a3.25 3.25 0 1 0 0 6.5 3.25 3.25 0 0 0 0-6.5M15.25 16a4.75 4.75 0 1 1 9.5 0 4.75 4.75 0 0 1-9.5 0",
  clipRule: "evenodd"
})))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
  id: "a"
}, /*#__PURE__*/React.createElement("path", {
  fill: "currentColor",
  d: "M0 0h40v40H0z"
})), /*#__PURE__*/React.createElement("clipPath", {
  id: "b"
}, /*#__PURE__*/React.createElement("path", {
  fill: "currentColor",
  d: "M0 0h40v40H0z"
})), /*#__PURE__*/React.createElement("clipPath", {
  id: "c"
}, /*#__PURE__*/React.createElement("path", {
  fill: "currentColor",
  d: "M0 0h40v40H0z"
})))));
const ForwardRef = /*#__PURE__*/forwardRef(SvgProfile);
export default ForwardRef;